import { Input, Divider, Typography } from 'antd';
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import '../index.css';
import { textFound, textNotFound } from '../colors';
import { v4 as uuidv4 } from 'uuid';
import './Home.css'; // CSS 파일을 import합니다.
import { Row, Col } from 'antd';


const { Title, Paragraph, } = Typography;

const NicVendor = () => {
  useEffect(() => {
    axios.get("/api/v1/nicvendor_cnt").then((response) => {
      setTotNicCount(response.data.data.tot_len);      
    }).catch(function (error) {

      if (error.response) {
        // 요청이 전송되었고, 서버는 2xx 외의 상태 코드로 응답했습니다.
        //console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
      } else if (error.request) {
        // 요청이 전송되었지만, 응답이 수신되지 않았습니다. 
        // 'error.request'는 브라우저에서 XMLHtpRequest 인스턴스이고,
        // node.js에서는 http.ClientRequest 인스턴스입니다.
        console.log(error.request);
      } else {
        // 오류가 발생한 요청을 설정하는 동안 문제가 발생했습니다.
        console.log('Error', error.message);
      }
      console.log(error.config);
    });
  }, [])

  const [totNicCnt, setTotNicCount] = useState(null);
  const [responseResult, setResponseResult] = useState([]);
  const [isSearched, setIsSearched] = useState(false);

  const onSearch = async (value) => {
    //console.log("on search: " + value);
    if (value.length > 0) {
      const js = { keyword: value }; // JSON 형식의 데이터
      await axios.post("/api/v1/nicvendor", js).then((response) => {
        if (response.data.status === 1) {
          console.log(response.data.data);
          setResponseResult(response.data.data);
        }
      })
        .catch(function (error) {
          console.error('Error:', error);
        });
      setIsSearched(true);
    }
  }

  const onChange = (e) => {
    //console.log('onChange:', e.target.value);
    setIsSearched(false);
    if (e.target.value.length === 0) {
      setResponseResult([])
    }
  }

  function showResult() {
    return (
      responseResult && responseResult.map((data, index) => (
        <>
          <Title style={{ color: textFound }} key={uuidv4()} level={4}> OUI : {data.z_oui} &nbsp; &nbsp; 제조사 : {data.z_name} </Title>
          <Divider></Divider>
        </>
      ))
    );
  }

  const ShowTotNicCnt = totNicCnt===null ? (<div>loading...</div>) : (
    <Typography key={uuidv4()} variant="body2">현재까지 총 <font color="red">{totNicCnt.toLocaleString('ko-KR')}</font>개의 NIC 정보가 저장되고 있습니다.</Typography>
    )

  function printNotFound() {
    return (
      isSearched ? <Title style={{ color: textNotFound }} key={uuidv4()} level={3}> No manufacturer found </Title> : <></>
    )
  }

  return (
    <div>
      <Row justify="center">
        <Col xs={24} sm={24} md={20} lg={20} xl={20}>
        <h2>NIC 제조사 찾기</h2>
        <h4>Enter the mac address or oui : </h4>
        <Input.Search
          placeholder='XXXXXX or MM:MM:MM:00:00:00'
          style={{ marginBottom: 20, marginTop: 10, }}
          onSearch={onSearch}
          onChange={onChange}
        >
        </Input.Search>
        {ShowTotNicCnt}
        <Title level={3}>Result : </Title>
        <ul>
          {
            responseResult.length > 0 ? (showResult()) : (printNotFound())
          }
        </ul>
        <Divider />

        <Typography>
          <Title level={3}>MAC(media access control address)</Title>
          <Paragraph>
            네트워크 세그먼트의 데이터 링크 계층에서 통신을 위한 네트워크 인터페이스에 할당된 고유 식별자 입니다.
            총 48비트로 구성되어 있으며, 편의상 8비트씩 6자리로 구분하여 표기하는데, "MM:MM:MM:00:00:00" 이와 같은 형식입니다.
            처음 3개의 옥텟(전송 순서대로)은 조직 고유 식별자(OUI)이며, IEEE에 의해 고유하게 할당됩니다. 뒤의 세자리는 기기 고유코드 입니다.
          </Paragraph>
        </Typography>
        </Col>
      </Row>
    </div>
  );
}

export default NicVendor;